// Save only the visible client canvas. Styles are interned and fixed at capture
// time so changing the viewport or stylesheet cannot move old ink onto new text.
const PROPS = ['display','position','boxSizing','width','height','minWidth','minHeight','maxWidth','maxHeight','marginTop','marginRight','marginBottom','marginLeft','paddingTop','paddingRight','paddingBottom','paddingLeft','fontFamily','fontSize','fontWeight','fontStyle','lineHeight','letterSpacing','textAlign','textTransform','whiteSpace','color','backgroundColor','borderTop','borderRight','borderBottom','borderLeft','borderRadius','flexDirection','flexWrap','alignItems','justifyContent','gap','gridTemplateColumns','gridTemplateRows','gridColumn','gridRow','top','left','right','bottom','overflow','opacity','transform','transformOrigin','fill','stroke'];
const TAGS = new Set('div main section article p span strong small h1 h2 h3 h4 ul ol li table thead tbody tr th td svg g path rect line circle polyline polygon text tspan'.split(' '));
const ATTRS = new Set('viewBox preserveAspectRatio x y x1 x2 y1 y2 width height d points cx cy r rx ry fill stroke stroke-width stroke-linecap stroke-linejoin text-anchor transform colspan rowspan'.split(' '));
export function captureSlide(element) {
  if (!element) return null;
  // Layout size, not screen size: a slide is scaled to the window with a
  // transform, and the capture has to be in the slide's own units.
  const rect=element.getBoundingClientRect();
  const k=element.offsetWidth ? rect.width/element.offsetWidth : 1;
  const bounds={left:rect.left,top:rect.top,width:element.offsetWidth||rect.width,height:element.offsetHeight||rect.height};
  const styles=[], keys=new Map();
  function walk(node) {
    if (node.nodeType===3) return node.textContent;
    if (node.nodeType!==1 || !TAGS.has(node.localName) || node.matches('.conv-ink,.no-print,.sr-only')) return null;
    const css=getComputedStyle(node);
    if(css.display==='none' || css.visibility==='hidden') return null;
    const style={};
    for(const prop of PROPS) { const value=css[prop]; if(value && value!=='none' && value!=='normal' && value!=='auto' && value!=='0px') style[prop]=value; }
    // Defaults must be explicit to keep inherited app rules out of the capture.
    Object.assign(style,{margin:css.margin,padding:css.padding,boxSizing:css.boxSizing});
    const key=JSON.stringify(style);let index=keys.get(key);
    if(index===undefined){index=styles.length;keys.set(key,index);styles.push(style);}
    if(node.matches('.conv-subnav,.conv-superseded'))return {t:'div',s:index,a:{},c:[]};
    const attrs={};
    for(const a of node.attributes)if(ATTRS.has(a.name))attrs[a.name]=a.value;
    return {t:node.localName,s:index,a:attrs,c:Array.from(node.childNodes).map(walk).filter(n=>n!==null)};
  }
  const tree=walk(element);
  // The root's scale and its place in the on-screen frame belong to the
  // window, not to the page: the copy starts at its own top left, full size.
  if(tree && styles[tree.s]){const own={...styles[tree.s]};for(const k of ['transform','position','top','left','right','bottom'])delete own[k];styles.push(own);tree.s=styles.length-1;}
  const main = element.querySelector('.conv-main');
  const content = main ? main.getBoundingClientRect() : null;
  const contentBounds = content
    ? { x: (content.left - rect.left) / k, y: (content.top - rect.top) / k, width: content.width / k, height: content.height / k }
    : { x: 0, y: 0, width: bounds.width, height: bounds.height };
  return {v:1,width:bounds.width,height:bounds.height,contentBounds,styles,tree};
}
export function drawingBox(capture, strokes) {
  const width=capture?.width || 1000;
  const frame = capture?.contentBounds || { x:0, y:0, width, height:capture?.height || width*.5625 };
  let x=frame.x,y=frame.y,right=frame.x+frame.width,bottom=frame.y+frame.height;
  for(const s of strokes||[])for(const p of s.p||[])if(Array.isArray(p)&&p.every(Number.isFinite)){
    x=Math.min(x,p[0]*width-5);y=Math.min(y,p[1]*width-5);
    right=Math.max(right,p[0]*width+5);bottom=Math.max(bottom,p[1]*width+5);
  }
  return {x,y,width:right-x,height:bottom-y};
}
export const CAPTURE_TAGS=TAGS;
export const CAPTURE_ATTRIBUTES=ATTRS;

export const CAPTURE_STYLES = new Set([...PROPS, "margin", "padding"]);
